import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { TaskDtoKeysEnum } from '@zaoblako/shared/modules/task/enum/task-dto-keys.enum';
import type { TaskStatusFindInterface } from '@zaoblako/shared/modules/task/dtos/status/task-status-find.dto';

import * as yup from 'yup';

export interface TaskStatusTransitionFindInterface {
  /** Source BRS task status */
  fromStatus: TaskStatusFindInterface;
  /** Target BRS task status */
  toStatus: TaskStatusFindInterface;
  /** Transition name (to show in user interface) */
  name: string;
  /** Is manual (by user) switch allowed */
  isManualSwitchAllowed: boolean;
  /** Is comment required to create after status switch */
  isCommentRequired: boolean;
}

export const TaskStatusTransitionFindDto = SerdeDtoClass.create<TaskStatusTransitionFindInterface>(TaskDtoKeysEnum.TASKS_STATUS_TRANSITION_FIND_DTO, {
  fromStatus: {
    label: 'Исходный статус',
    nested: TaskDtoKeysEnum.TASKS_STATUS_FIND_DTO,
    serializer: (_, nested) => nested,
  },
  toStatus: {
    label: 'Целевой статус',
    nested: TaskDtoKeysEnum.TASKS_STATUS_FIND_DTO,
    serializer: (_, nested) => nested,
  },
  name: {
    label: 'Имя',
    serializer: yup.string(),
  },
  isManualSwitchAllowed: {
    label: 'Разрешено ли ручное переключение',
    serializer: yup.boolean(),
  },
  isCommentRequired: {
    label: 'Обязательный комментарий',
    serializer: yup.boolean(),
  },
});
